import { memo } from "react";
import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { useSideMenuPC } from "./hooks";
import { SideMenuPCPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const SideMenuPCContainer = memo(({ hotelID }: Props) => {
	const { sideMenuData, hotelApplicationData } = useSideMenuPC({ hotelID });

	if (!sideMenuData) {
		return <Navigate to={generatePath(PATHS.TOP)} />;
	}

	return (
		<SideMenuPCPresenter
			hotelID={hotelID}
			sideMenuData={sideMenuData}
			hotelApplicationData={hotelApplicationData}
		/>
	);
});

SideMenuPCContainer.displayName = "SideMenuPCContainer";
